import { render, staticRenderFns } from "./AccessControlForm.vue?vue&type=template&id=21eb0bab"
import script from "./AccessControlForm.vue?vue&type=script&lang=js"
export * from "./AccessControlForm.vue?vue&type=script&lang=js"
import style0 from "./AccessControlForm.vue?vue&type=style&index=0&id=21eb0bab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports